import processQuery from "@/services/genAiService/processQuery";

export default {
  processQuery,
};
